


















































import HomeAlertasStore from '@/components/Home/Store/HomeAlertasStore'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { contains } from '@/utils/common'
import moment from 'moment'

@Component
export default class ComponentCardAlertas extends Vue {
  alertaEnabled: boolean = false
  dataReady: boolean = false

  get getHomeAlertasStore() {
    return getModule(HomeAlertasStore, this.$store)
  }

  get tableHeader() {
    return this.getHomeAlertasStore.alertasTableHeader
  }

  get alertas() {
    return this.getHomeAlertasStore.alertas
  }

  get totalDeAlertas() {
    return this.getHomeAlertasStore.alertas.length
  }

  humanizedTime(tempo) {
    return moment.duration(tempo, 'minutes').locale('pt').humanize()
  }

  resolverPendencia(id: string) {
    //
  }

  async init() {
    const request = await this.getHomeAlertasStore.getAlertasSummaryData()
    this.dataReady = request.success
  }

  async created() {
    if (contains(this.$user.profile.pageAuthorized, ['agendamento-medico'])) {
      this.alertaEnabled = true
      await this.init()
    }
  }

  windowWidth: number = 0

  get mobileBreakpoint() {
    return this.windowWidth < 768
  }

  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }
}
